var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8563 13.75L28.8466 13.7457L2.98823 3.02046C2.77074 2.92943 2.53407 2.89373 2.29939 2.91655C2.06472 2.93937 1.83937 3.02001 1.64349 3.15124C1.43653 3.28685 1.26654 3.47178 1.1488 3.68939C1.03107 3.90701 0.969276 4.15048 0.968994 4.3979V11.2573C0.969109 11.5955 1.08722 11.9231 1.30296 12.1836C1.51871 12.4441 1.81857 12.6212 2.15087 12.6843L16.254 15.2921C16.3095 15.3026 16.3595 15.3321 16.3955 15.3756C16.4314 15.419 16.4511 15.4736 16.4511 15.5301C16.4511 15.5865 16.4314 15.6411 16.3955 15.6845C16.3595 15.728 16.3095 15.7575 16.254 15.768L2.15147 18.3758C1.81927 18.4387 1.51942 18.6156 1.30358 18.8758C1.08774 19.1361 0.969418 19.4635 0.968994 19.8016V26.6622C0.968834 26.8985 1.02733 27.1311 1.13924 27.3391C1.25116 27.5472 1.41298 27.7243 1.61019 27.8544C1.84741 28.012 2.12581 28.0962 2.41062 28.0965C2.60862 28.0964 2.80459 28.0566 2.98702 27.9797L28.8448 17.3156L28.8563 17.3101C29.2043 17.1605 29.5009 16.9122 29.7093 16.5958C29.9177 16.2794 30.0288 15.9089 30.0288 15.5301C30.0288 15.1512 29.9177 14.7807 29.7093 14.4643C29.5009 14.1479 29.2043 13.8996 28.8563 13.75Z",
    fill: "#1B1F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.da6a65a627f3606754382eff7801fc49.svg";
export { ForwardRef as ReactComponent };